import { message, Tooltip } from "antd";
import { combineBrokersFirmName } from "../../CreateOffer/features/helperFunctions";
import { buyerCustomerDocsContractTypes } from "../../Common/commondata/commonData";
import { getFullNamesFromArray } from "../../Common/utils/ExtraFunctions";
import axios from "axios";
const apiURL = process.env.REACT_APP_BASE_URL;
export const checkAllRequiredFields = (CurrentPdfImportData) => {
  if (!Object.keys(CurrentPdfImportData)?.length) return false;
  const requiredFields = ["Buyers", "FullAddress",  "PurchasePrice", "EarnestMoney", "CashAtClosing", "ClosingDate"];

  // checking if all required fields are present and have non-empty values
  for (const field of requiredFields) {
    if (!CurrentPdfImportData.hasOwnProperty(field) || (Array.isArray(CurrentPdfImportData[field]) && CurrentPdfImportData[field].length === 0) || !CurrentPdfImportData[field]) {
      return false;
    }
  }
  isAtleastOneClientPresent(CurrentPdfImportData.Buyers);

  return true;
};

export const isAtleastOneClientPresent = (clients) => {
  if (Array.isArray(clients) && clients.length > 0) {
    for (const client of clients) {
      if (client.isCorp && client.signers.length > 0) {
        return true;
      } else if (!client.isCorp && client.fullName) {
        return true;
      }
    }
  }
  return false; 
};

export const getPropertyImages = (ele) => {
  if(!typeof ele === "object") return "";
  if(ele?.propertyType?.includes("PRIVATE")){
    return (<Tooltip placement="top" title="Unlisted"><img style={{width: "29px", borderRadius: "2px", cursor: "pointer"}} src="https://resureprojectbucket.s3.us-east-2.amazonaws.com/dev/65b8f71bdff9fe6ba44c8501/MEMORIES/16RE-Sure%20Blue%20Bug.png" alt="Unlisted"/></Tooltip>)
  }
  else if(ele?.propertyType?.some(ele => ele.includes("RECOLORADO"))){
    return (<Tooltip placement="top" title="REcolorado"><img style={{width: "38px", cursor: "pointer"}} src="https://resureprojectbucket.s3.us-east-2.amazonaws.com/dev/64d5ce64dff9fe6ba4cfaf06/MEMORIES/18pastedImage82704" alt="REcolorado"/></Tooltip>)
  }
  else if(ele?.propertyType?.some(ele => ele.includes("IRES"))){
    return (<Tooltip placement="top" title="IRES"><img style={{width: "54px", height: "24px", cursor: "pointer"}} src="https://resureprojectbucket.s3.us-east-2.amazonaws.com/dev/64d5ce64dff9fe6ba4cfaf06/MEMORIES/18pastedImage84057" alt="IRES"/></Tooltip>)
  }
  else if(ele?.propertyType?.some(ele => ele.includes("PPAR"))){
    return (<Tooltip placement="top" title="PPAR"><img style={{width: "38px", cursor: "pointer"}} src="https://resureprojectbucket.s3.us-east-2.amazonaws.com/dev/657ff2157e660a0701cfaa24/MEMORIES/19PPMLS-logo-MAIN-WebRGB.jpeg" alt="PPAR"/></Tooltip>);
  }
  else if(ele?.propertyType?.some(ele => ele.includes("PAR"))){
    return (<Tooltip placement="top" title="PAR"><img style={{width: "38px", cursor: "pointer"}} src="https://resureprojectbucket.s3.us-east-2.amazonaws.com/qa/6444b9c521382a6780572f63/MEMORIES/2pastedImage68271" alt="PAR"/></Tooltip>);
  }
  else if(ele?.propertyType?.some(ele => ele.includes("VAIL"))){
    return (<Tooltip placement="top" title="VAIL"><img style={{width: "50px", cursor: "pointer"}} src="https://resureprojectbucket.s3.us-east-2.amazonaws.com/prod/64cb4128b00a232d9c2cc0d4/MEMORIES/2025-08-21T09%3A11%3A23.551Z-Vail.jpg" alt="VAIL"/></Tooltip>);
  }
  else if(ele?.propertyType?.some(ele => ele.includes("GJAR"))){
    return (<Tooltip placement="top" title="GJAR"><img style={{width: "78px", cursor: "pointer"}} src="https://resureprojectbucket.s3.us-east-2.amazonaws.com/prod/64cb4128b00a232d9c2cc0d4/MEMORIES/29gjara-logo.png" alt="GJAR"/></Tooltip>);
  }
  else if(ele?.propertyType?.some(ele => ele.includes("WYO"))){
    return (<Tooltip placement="top" title="WYOMING"><img style={{width: "77px", cursor: "pointer"}} src="https://resureprojectbucket.s3.us-east-2.amazonaws.com/qa/658abc9e00b066ebf7dfdce9/MEMORIES/2025-08-11T10%3A45%3A15.074Z-C71A79F0-74CF-4B1B-88A9-F90FF9FDA234.jpg" alt="WYOMING"/></Tooltip>);
  }
  else return "";
}

export const getBuildDataForCustomerdocs = ({ clientDocId, contractType, contractId, currentSellerAgentData, delegate, transactionData = {}, item, officeDetails, docSecondItem,userAuthKey }) => {
  
  let BuyerAgents = [],
    SellerAgents = [];
  let Buyers = [];
  let Sellers = [];
  const isBuyerCustomerDoc = buyerCustomerDocsContractTypes.includes(contractType);
  if (isBuyerCustomerDoc) {
    Buyers = item?.isProperty ? transactionData?.Sellers : transactionData?.Buyers;
    BuyerAgents = item?.isProperty ? transactionData?.SellerAgents : transactionData?.BuyerAgents;
  } else {
    Sellers = item?.isProperty ? transactionData?.Sellers : transactionData?.Buyers;
    SellerAgents = item?.isProperty ? transactionData?.SellerAgents : transactionData?.BuyerAgents;
  }

  let buildData = {
    urlData: {
      ...(isBuyerCustomerDoc && Buyers?.length ? { Buyers } : Sellers?.length ? { Sellers } : {}),
      ...(BuyerAgents?.length > 0 ? { BuyerAgents, BuyerBrokersList: getFullNamesFromArray(BuyerAgents), BuyerBrokersFirmList: combineBrokersFirmName(BuyerAgents) } : {}),
      ...(SellerAgents?.length > 0 ? { SellerAgents, SellerBrokersList: getFullNamesFromArray(SellerAgents), SellerBrokersFirmList: combineBrokersFirmName(SellerAgents) } : {}),

      ...(docSecondItem?.contractType === "LCAE" ? { LcaeCheckedListingContract: "ERTBListingContract" } : docSecondItem?.contractType === "LCAES_ERTL" ? { LcaeCheckedListingContract: "ERTLListingContract" } : docSecondItem?.contractType === "LCAES_ETCT" ? { LcaeCheckedListingContract: "ExclusiveTenantListingContract" } : {}),

      ...(docSecondItem?.contractType === "LCAE" ? { LcaeInitatingParty: "LcaeInitatingPartyBuyer" } : docSecondItem?.contractType === "LCAES_ERTL" ? { LcaeInitatingParty: "LcaeInitatingPartyLandlord" } : docSecondItem?.contractType === "LCAES_ETCT" ? { LcaeInitatingParty: "LcaeInitatingPartyTenant" } : {}),
      officeDetails,
      ...(docSecondItem?.contractType ? { ...transactionData } : {}),
    },
    openFor: isBuyerCustomerDoc ? "BUYER_AGENT" : "SELLER_AGENT",
    RTDInitiator: isBuyerCustomerDoc ? "BUYER" : "SELLER",
    ...(delegate ? { delegateOwnerId: currentSellerAgentData?._id } : {}),
    ...(docSecondItem?.contractType && clientDocId ? { clientDocId } : {}),
    ...(docSecondItem?.contractType === "LCAES" ? { propertyId: item?.propertyId } : {}),
    openForPropertyDoc: isBuyerCustomerDoc ? "BUYER_AGENT" : "SELLER_AGENT",
    contractId: contractId,
    contractType: contractType,
    token: userAuthKey,
    builtForSection: "DOCUMENT",
    builtForId: currentSellerAgentData?._id,
    key: currentSellerAgentData?._id,
    signable: true,
  };
  return buildData;
};
export const getPreSignedUrls = async ({ filenames, accessToken, type }) => {
  let accessTokan2 = localStorage.getItem("auth");
  let folderOf;
  if (type === "UPLOAD_DOC") {
    folderOf = "PDF_DOC";
  } else if (type === "NewsLetter") {
    folderOf = "NewsLetter";
  } else if (type === "BROKERAGE") {
    folderOf = "BROKERAGE";
  }
  try {
    const payload = {
      filenames,
      ...(folderOf && { folderOf }), // Add folderOf only if it's defined
    };
    const response = await axios.post(`${apiURL}/generatePreSignedUrls`, payload, {
      headers: {
        accept: "application/json",
        authorization: `bearer ${accessToken || accessTokan2}`,
      },
    });
    return response?.data?.info;
  } catch (error) {
    message.error("Failed to get pre-signed URLs. Please try again.");
    return null;
  }
};
// Function to upload a file to a pre-signed URL
export const uploadFileToS3 = async (file, uploadUrl) => {
  try {
    const arrayBuffer = await file.arrayBuffer();
    const response = await axios.put(uploadUrl, arrayBuffer, {
      headers: {
        "Content-Type": file.type,
        "Content-Length": arrayBuffer.byteLength,
      },
      transformRequest: [(data) => data],
    });
    if (response?.status === 200) {
      const responseURL = new URL(response?.request?.responseURL);
      return `${responseURL?.origin}${responseURL?.pathname}`;
    } else {
      message.error(`Failed to upload file: ${file?.name}`);
      return null;
    }
  } catch (error) {
    message.error(`Error uploading file: ${file?.name}`);
    return null;
  }
};

export const renderWithChange = ({ data, key, content, style = {}, showAsterisk = true }) => {
  const isChanged = data?.[`${key}_Changed`];

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "4px",
        ...style,
      }}
    >
      {content}
      {isChanged && showAsterisk && (
        // <Tooltip title="Original offer value has been updated." placement="top">
          <span style={{ color: "blue", fontWeight: "bold", }}>*</span>
        // </Tooltip>
      )}
    </span>
  );
};

